export default function PrivacyPolicy() {
  return (
    <div style={{ fontFamily: '-apple-system,BlinkMacSystemFont,sans-serif', maxWidth: '800px', margin: '0 auto', padding: '3rem 2rem', color: '#1a1a1a', lineHeight: '1.8' }}>
      <div style={{ marginBottom: '2rem' }}>
        <a href="/" style={{ color: '#666', fontSize: '14px', textDecoration: 'none' }}>← Back to SellerDash</a>
      </div>
      <h1 style={{ fontSize: '32px', fontWeight: '600', marginBottom: '0.5rem' }}>Privacy Policy</h1>
      <p style={{ color: '#888', fontSize: '14px', marginBottom: '3rem' }}>Last updated: 22 May 2026</p>

      <section style={{ marginBottom: '2rem' }}>
        <h2 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '1rem' }}>1. Who we are</h2>
        <p>SellerDash is a SaaS product operated by Rozac Ltd, based in the United Kingdom. We provide a dashboard for Amazon FBA sellers to track their sales, fees, inventory and profit. Our website is knotyourtype.co.uk.</p>
        <p>For any privacy related questions, contact us at: <a href="mailto:privacy@knotyourtype.co.uk" style={{ color: '#378ADD' }}>privacy@knotyourtype.co.uk</a></p>
      </section>

      <section style={{ marginBottom: '2rem' }}>
        <h2 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '1rem' }}>2. What data we collect</h2>
        <p>We collect the following data when you use SellerDash:</p>
        <ul style={{ paddingLeft: '1.5rem' }}>
          <li style={{ marginBottom: '0.5rem' }}><strong>Account data:</strong> Your name, email address and password (stored as a secure hash)</li>
          <li style={{ marginBottom: '0.5rem' }}><strong>Amazon data:</strong> Sales data, order data, inventory levels, financial events, and fee information retrieved via the Amazon Selling Partner API (SP-API) on your behalf</li>
          <li style={{ marginBottom: '0.5rem' }}><strong>Payment data:</strong> Subscription status and billing information processed by Stripe. We do not store card details.</li>
          <li style={{ marginBottom: '0.5rem' }}><strong>Usage data:</strong> Basic usage information to improve our service</li>
        </ul>
      </section>

      <section style={{ marginBottom: '2rem' }}>
        <h2 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '1rem' }}>3. How we use your data</h2>
        <p>We use your data solely to provide the SellerDash service:</p>
        <ul style={{ paddingLeft: '1.5rem' }}>
          <li style={{ marginBottom: '0.5rem' }}>To display your Amazon sales, fees, inventory and profit data in your dashboard</li>
          <li style={{ marginBottom: '0.5rem' }}>To send you stock alert emails when your inventory runs low</li>
          <li style={{ marginBottom: '0.5rem' }}>To process your subscription payment via Stripe</li>
          <li style={{ marginBottom: '0.5rem' }}>To send you important service updates and notifications</li>
        </ul>
        <p>We <strong>never</strong> sell your data to third parties. We <strong>never</strong> use your Amazon data for any purpose other than providing the SellerDash service to you.</p>
      </section>

      <section style={{ marginBottom: '2rem' }}>
        <h2 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '1rem' }}>4. Amazon SP-API data</h2>
        <p>SellerDash connects to Amazon's Selling Partner API (SP-API) on your behalf using OAuth 2.0. We access the following Amazon data:</p>
        <ul style={{ paddingLeft: '1.5rem' }}>
          <li style={{ marginBottom: '0.5rem' }}>Orders and order items</li>
          <li style={{ marginBottom: '0.5rem' }}>Financial events and fees</li>
          <li style={{ marginBottom: '0.5rem' }}>FBA inventory levels</li>
          <li style={{ marginBottom: '0.5rem' }}>Payout and settlement data</li>
        </ul>
        <p>This data is stored securely in our database and is only accessible by you through your SellerDash account. You can revoke our access to your Amazon account at any time through Amazon Seller Central.</p>
      </section>

      <section style={{ marginBottom: '2rem' }}>
        <h2 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '1rem' }}>5. Data storage and security</h2>
        <p>Your data is stored securely on Railway's cloud infrastructure within the European Union. We use industry-standard security practices including:</p>
        <ul style={{ paddingLeft: '1.5rem' }}>
          <li style={{ marginBottom: '0.5rem' }}>Encrypted connections (HTTPS/TLS) for all data in transit</li>
          <li style={{ marginBottom: '0.5rem' }}>Encrypted passwords using bcrypt hashing</li>
          <li style={{ marginBottom: '0.5rem' }}>JWT tokens for secure authentication</li>
          <li style={{ marginBottom: '0.5rem' }}>Access controls to prevent unauthorised access</li>
        </ul>
      </section>

      <section style={{ marginBottom: '2rem' }}>
        <h2 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '1rem' }}>6. Your rights (GDPR)</h2>
        <p>As a UK/EU resident you have the following rights:</p>
        <ul style={{ paddingLeft: '1.5rem' }}>
          <li style={{ marginBottom: '0.5rem' }}><strong>Right to access:</strong> Request a copy of all data we hold about you</li>
          <li style={{ marginBottom: '0.5rem' }}><strong>Right to erasure:</strong> Request deletion of your account and all associated data</li>
          <li style={{ marginBottom: '0.5rem' }}><strong>Right to rectification:</strong> Request correction of inaccurate data</li>
          <li style={{ marginBottom: '0.5rem' }}><strong>Right to portability:</strong> Request your data in a portable format</li>
          <li style={{ marginBottom: '0.5rem' }}><strong>Right to object:</strong> Object to processing of your data</li>
        </ul>
        <p>To exercise any of these rights, email us at <a href="mailto:privacy@knotyourtype.co.uk" style={{ color: '#378ADD' }}>privacy@knotyourtype.co.uk</a></p>
      </section>

      <section style={{ marginBottom: '2rem' }}>
        <h2 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '1rem' }}>7. Data retention</h2>
        <p>We retain your data for as long as your account is active. When you cancel your account we delete all your personal data and Amazon data within 30 days. Anonymised usage statistics may be retained for longer.</p>
      </section>

      <section style={{ marginBottom: '2rem' }}>
        <h2 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '1rem' }}>8. Third party services</h2>
        <p>We use the following third party services:</p>
        <ul style={{ paddingLeft: '1.5rem' }}>
          <li style={{ marginBottom: '0.5rem' }}><strong>Stripe</strong> — payment processing (<a href="https://stripe.com/privacy" style={{ color: '#378ADD' }}>Stripe Privacy Policy</a>)</li>
          <li style={{ marginBottom: '0.5rem' }}><strong>Railway</strong> — cloud hosting and database</li>
          <li style={{ marginBottom: '0.5rem' }}><strong>Vercel</strong> — frontend hosting</li>
          <li style={{ marginBottom: '0.5rem' }}><strong>Resend</strong> — email delivery</li>
          <li style={{ marginBottom: '0.5rem' }}><strong>Amazon SP-API</strong> — Amazon seller data</li>
        </ul>
      </section>

      <section style={{ marginBottom: '2rem' }}>
        <h2 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '1rem' }}>9. Cookies</h2>
        <p>SellerDash uses minimal cookies — only those necessary for authentication and session management. We do not use advertising or tracking cookies.</p>
      </section>

      <section style={{ marginBottom: '2rem' }}>
        <h2 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '1rem' }}>10. Changes to this policy</h2>
        <p>We may update this privacy policy from time to time. We will notify you of significant changes by email. Continued use of SellerDash after changes means you accept the updated policy.</p>
      </section>

      <section style={{ marginBottom: '2rem' }}>
        <h2 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '1rem' }}>11. Contact us</h2>
        <p>For any privacy questions or to exercise your rights, contact us at:</p>
        <p><strong>Rozac Ltd</strong><br />
        Email: <a href="mailto:privacy@knotyourtype.co.uk" style={{ color: '#378ADD' }}>privacy@knotyourtype.co.uk</a></p>
      </section>
    </div>
  );
}